import {t} from 'i18next';

export const errorMaps: Record<string, Record<string, string>> = {
  UserManagement: {
    '20001000011': 'A user with same role exists in the same project.',
    '20001000012':
      'A user with same role exists in the same security group in same project.',
    '20001000013': 'A user does not belong to the project IP range.',
    '20001000014': 'You cannot add system administrator to any other role.',
    '20001000015': 'User is not allowed for this domain and role.',
    '20001000016': 'User does not exist in the system.',
    '20001000018':
      'Login failed. You don’t have a project assigned. Please contact administrator.',
    '20001000019':
      'Login failed. User is not active. Please contact administrator.',
    '20001000020':
      'Your account has been locked. Please contact administrator.',
    '20001000021': 'User cannot be created at this level.',
    '20001000022':
      'Your account has been locked for the project. Please contact administrator.',
    '20001000023': 'User already exists in the project with a different role.',
    '20001000024':
      'User already exists in the project in one or more of the selected security groups.',
    '20001000025': 'User already invited in the project with a different role.',
    '20001000026':
      'User already invited in the project in one or more of the selected security groups.',
    '20001000027': 'User already exists in the project with the same role.',
    '20001000028': 'User already exists with system admin role.',
    '20001000029': 'Security group with given name already exists.',
    '20001000030': 'Cannot create users above your current role.',
    '20001000031': 'Cannot create users out of your current context.',
    '20001000032':
      'User not permitted to impersonate with the supplied credentials.',
    '20001000034':
      'You cannot assign the same user to different security groups of the same project with differing billability attributes.',
    '20001000035':
      'IP address of user does not belong to the restricted IP range of the project.',
    '20001000036':
      'For a Single-Sign-On user, password reset is not available to log into Aurora Review.',
    '20001000037':
      'This username is not setup for SSO login. Please use your credentials or contact administrator.',
    '20001000038':
      'User is part of multiple SSO clients. Remove from extra domains or disable SSO.',
    '20001000039':
      'This username is not setup for SSO login. Please contact administrator.',
    '20001000040':
      'User already exists in Aurora Review. Use Edit User to change SSO settings.',
    '20001000041':
      'User already exists in Aurora Review. Use Edit User to change SSO settings.',
    '20001000042': 'This username is not setup for SSO login.',
    '20001000043': 'General login failed error scenario.',
    '20001000044': 'Failed to complete SSO Sign-In after redirect.',
    '20001000045':
      'This username is incorrect. User does not exist in system (SSO check).',
    '20001000046':
      'Error occurred while updating user details. Legal Hold user creation failed.',
    '20001000047':
      'Forgot password locked due to too many attempts. Retry later or contact administrator.',
    '20001000048':
      'You do not have access to this document. Please contact administrator.',
    '20001000049':
      'Selected user email domains are not in the permitted list (RMU - Project).',
    '20001000050':
      'Selected user email domains are not in the permitted list (RU).',
    '20001000051':
      'Selected user email domains are not in the permitted list (RU - Project).',
    '20001000052':
      'Selected user email domains are not in the permitted list (Entity level Domain).',
    '20001000053': 'Selected entity is not a domain entity.',
    '20001000054': 'Selected user email domains are not in the permitted list.',
    '20001000055':
      'Selected user email domains are not in the permitted list (ProjectAdmin).',
    '20001000056':
      'Selected user email domains are not in the permitted list (RMU).',
    '20001000057': 'Something went wrong. emailLinkUrl is empty or NULL.',
    '20001000058':
      'Something went wrong. User email does not exist in SA role.',
  },
  Ingestion: {
    '12001000001':
      'Release all documents first from all security groups and then perform the unpublish.',
  },
  DocumentManagement: {
    '30001000110':
      'Comment is used in Coding form. Please remove Comment from coding form.',
  },
  AddProjectField: {
    '30001000001':
      'A project field with this name already exists. Please choose a different name.',
  },
  ClientManagement: {
    '30001000028':
      'You cannot delete this client as there is a project associated with it',
    '30001000006': 'The client was not created due to an error',
    '30001000007': 'The client was not updated due to an error',
    '30001000008': 'The client did not get deleted due to an error',
    '25001000001':
      'This name is already taken. Please choose another 4 character name.',
    '25001000002': 'This name is already taken.',
    '25001000003': 'This Domain ID is already taken.',
    '25001000004':
      'Cannot change ICE Instance once project is created under the entity',
  },
  Reporting: {
    '11001000001': 'Report FileName Already Exists',
  },
  // Add more modules as needed
};

const localizedErrorMaps = (module: string, code: string): string => {
  return t(`apiErrors.${module}.${code}`);
};

export {localizedErrorMaps};
